import RocketBg from 'assets/images/dashboard/rocket.png';
import GoatBg from 'assets/images/dashboard/goat.png';
import { GradientBorderBox } from 'components/styled/Box';
import styled, { css } from 'styled-components';

// card bg
const cardWithRocket = (props: { cardBg?: string; icon: string }) => css`
    background-image: url(${props.icon === 'goat' ? GoatBg : RocketBg}), url(${props.cardBg});
    background-repeat: no-repeat;
    background-size: ${props.icon === 'goat' ? '78px auto' : '68px auto'}, cover;
    background-position: ${props.icon === 'goat' ? 'calc(100% - 8px) bottom' : 'calc(100% - 20px) center'}, 100% 100%;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        background-size: ${props.icon === 'goat' ? '78px auto' : '58px auto'}, cover;
    `};
`;
const cardWithoutRocket = (props: { cardBg?: string }) => css`
    background-image: ${props.cardBg ? `url(${props.cardBg})` : undefined};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 100% 100%;
`;

export const Card = styled.div<{
    background?: string;
    backgroundImage?: string;
    borderRadius?: string;
    padding?: string;
    height?: string;
    marginBottom?: string;
    width?: string;
    bgIcon?: 'rocket' | 'goat';
}>`
    background: ${({ background }) => background};

    ${({ backgroundImage, bgIcon }) =>
        backgroundImage && bgIcon
            ? cardWithRocket({ cardBg: backgroundImage, icon: bgIcon })
            : cardWithoutRocket({ cardBg: backgroundImage })}

    border-radius: ${({ borderRadius }) => borderRadius || '8px'};
    padding: ${({ padding }) => padding || '20px'};
    height: ${({ height }) => height || 'auto'};
    margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
    width: ${({ width }) => width || 'auto'};
    /* backdrop-filter: blur(5px); */
`;

export const Tag = styled(GradientBorderBox)`
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
    margin-top: 6px;
`;

export const Board = styled.div`
    background: radial-gradient(
        71.69% 34.22% at 100% 0%,
        var(--Background-Background-Brand-1-30, rgba(106, 13, 173, 0.3)) 0%,
        var(--Background-Primary, #000) 100%
    );
`;

export const Wrapper = styled(Card)`
    padding: 45px 30px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 20px;
    `}
    ${({ theme }) => theme.mediaWidth.upToExtraSmall`
        padding: 10px;
    `}
`;

export const StyledSocialCardWrapper = styled.div<{
    disabled?: boolean;
}>`
    position: relative;
    &::before {
        content: ${({ disabled }) => (disabled ? "'Coming soon'" : "'Live'")};
        padding: 4px 10px;
        font-size: 12px;
        border-radius: 0 10px;
        position: absolute;
        top: 0;
        right: 0;
        background: ${({ theme, disabled }) => (disabled ? theme.c.primary01 : theme.c.success)};
        color: #000;
        z-index: 1;
    }
`;
export const StyledSocialCard = styled(GradientBorderBox).attrs((props) => ({
    gradient: `linear-gradient(180deg,  ${props.theme.c.primary01} 0%, ${props.theme.c.primary02} 50%, #000 100%)`,
    borderRadius: 10,
    padding: '40px 20px 20px',
}))<{ disabled?: boolean; flex?: number }>`
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    user-select: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    position: relative;
    flex: ${({ flex }) => flex || 1};
`;

export const StyledClaimCard = styled(GradientBorderBox).attrs((props) => ({
    gradient: `linear-gradient(180deg,  ${props.theme.c.primary01} 0%, ${props.theme.c.primary02} 50%, #000 100%)`,
    borderRadius: 10,
    padding: '20px',
}))<{ disabled?: boolean; flex?: number; height?: string }>`
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    user-select: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    position: relative;
    flex: ${({ flex }) => flex || 1};
    height: ${({ height }) => height || 'auto'};
    ${({ theme }) => theme.mediaWidth.upToSmall`
        flex: 1;
        width: 100%;
    `}
`;
